import { ListFilter } from "lucide-react";
import { Button } from "../../../../../@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../../../@/components/ui/dropdown-menu";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";

interface LeadStatusDropDownProps {
  selectedStatus: string;
  handleCheckboxChange: (backendStatus: string, checked: boolean) => void;
}

export default function StatusFilterDropdownComponent({
  selectedStatus,
  handleCheckboxChange,
}: LeadStatusDropDownProps) {
  const templateStatusList = useSelector((state: RootState) => state.lead.selectedStatusesLeadTab);
  console.log("jjj",templateStatusList)
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 gap-1 text-sm">
            <ListFilter className="h-4 w-4" />
            <span className="sr-only sm:not-sr-only">Filter</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Filter by Status</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {templateStatusList.map((status: string) => (
            <DropdownMenuCheckboxItem
              key={status}
              checked={selectedStatus === status}
              onCheckedChange={(checked) => handleCheckboxChange(status, checked)}
            >
              {status}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
